import React from "react";
import Header from "../../common/Header";
import preve_arrow from "../../../images/prve-arrow.png";
import { useNavigate } from "react-router-dom";
import { Tabs } from "antd";

const SocietyImagesComponent = (props) => {
  const { items, alignValue, onChange } = props;
  const navigate = useNavigate();
  return (
    <>
      <Header title="Images & Logo" />
      <div className="header-title" onClick={() => navigate("/society-list")}>
        <img src={preve_arrow} alt="preve_arrow" className="preve_arrow" />
        <span> Society List</span>
      </div>
      <div className="permission-container">
        <div className="permission-title">
          <h2>Scociety Images</h2>
        </div>
        <div className="tabs-container">
          <Tabs
            defaultActiveKey="1"
            items={items}
            onChange={onChange}
            indicator={{
              size: (origin) => origin - 20,
              align: alignValue,
            }}
          />
        </div>
      </div>
    </>
  );
};

export default SocietyImagesComponent;
